export default __webpack_public_path__ + "static/media/about-background-mobile.c792486c.svg";